import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { Store } from '@ngrx/store';
import { ServiceTypeGridObject } from '@it2go/types';
import { map } from 'rxjs/operators';
import { ServiceService } from '../../../../../services/service.service';

interface State {
    serviceTypes: ServiceTypeGridObject | null,
}

const defaultState: State = {
    serviceTypes: null,
};

@Injectable()
export class ServiceTypeSelectStore extends ComponentStoreFactory<State> {

    serviceTypes$ = this.data.serviceTypes$.pipe(map(
        (it) => it?.['items'] || [],
    ));

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }

}
